import { actionEditorStore } from "../stores/ActionEditorStore";
import { gameStore } from "../stores/GameStore";
import { sharedStore } from "../stores/SharedStore";
export function getActionShortDescriptionForActionEditor(action, t) {
  return action.shortDescription([actionEditorStore.currentRootActionTree, sharedStore.mainGameRootActionTree], t, gameStore.languageKey, id => sharedStore.characterConfigurations.get(id));
}